<template>
    <div>
        <div class="wrapper">
            <div class="col12 pt-0">
                <h1 class="page_title">機器レンタルプランのお申し込み</h1>
                <div class="signup_flow">
                    <ol>
                        <li class="current"><span>1</span>ログ <br class="on-sp" />イン</li>
                        <li><span>2</span>申込 <br class="on-sp" />内容</li>
                        <li><span>3</span>情報 <br class="on-sp" />入力</li>
                        <li><span>4</span>支払</li>
                        <li><span>5</span>完了</li>
                    </ol>
                </div>
                <!-- signup_flow -->
            </div>
        </div>
        <!-- wrapper -->

        <section class="container">
            <div class="wrapper">
                <h2 class="col5 section_title">
                    <strong> 本サイトについて </strong>
                </h2>
                <div class="col7 input_area">
                    <h3 class="strong big-16 mb-05em">本サイトでは以下のサービスへのお申し込みが可能です。</h3>
                    <ul class="list-disc">
                        <li>ネコリコチャンネル with LTE 機器レンタルプラン</li>
                    </ul>
                    <br />
                    <h3 class="strong big-16 mb-05em">本サービスには以下の内容が含まれています。</h3>
                    <ul class="list-disc">
                        <li>「BOCCO emo LTE モデル Powered by ネコリコ」レンタルサービス</li>
                        <li>ネコリコチャンネル with LTE サービス</li>
                    </ul>
                    <br />
                    <h3 class="strong big-16 mb-05em">一度のお申し込みで複数台分の契約はできません。必要回数分お申し込みをお願いします。</h3>

                    <hr class="thick" />

                    <h3 class="strong big-16 mb-05em">お申込みに必要なもの</h3>
                    <ul class="list-disc">
                        <li>クレジットカード（VISA,Master,JCB,AMX,Diners）</li>
                    </ul>

                    <hr class="thick" />

                    <h3 class="strong big-16 mb-05em">個人情報の取扱について</h3>
                    <dl>
                        <dd>
                            <p>個人情報保護方針および特定商取引に基づく表記(<a href="https://www.necolico.co.jp/privacypolicy/" target="_blank">外部リンク</a>)</p>
                        </dd>
                    </dl>
                    <hr class="thick" />
                </div>
                <h2 class="col5 section_title">
                    <strong>サービス契約内容</strong>
                </h2>
                <div class="col7 input_area">
                    <ul class="default_list mt-0">
                        <li>
                            <span>レンタル機器</span>
                            <span>BOCCO emo LTE モデル Powered by ネコリコ (一式)</span>
                        </li>
                        <li>
                            <span>料金</span>
                            <span>&yen;2,970-(税込)</span>
                        </li>
                        <li>
                            <span>支払い周期</span>
                            <span>毎月更新日払い</span>
                        </li>
                        <li>
                            <span>最低利用期間</span>
                            <span>12ヶ月</span>
                        </li>
                        <li>
                            <span>最低利用期間中の解約金</span>
                            <span>&yen;8,800-(税込)</span>
                        </li>
                    </ul>
                    <img src="/img/EmoSet.png" alt="BOCCO emo LTEモデル Powered by ネコリコ" />
                    <br /><br />
                    <h3 class="strong big-16 mb-05em">セット内容(詳細)</h3>
                    <p>
                        1) BOCCO emo LTEモデル 本体<br />
                        2) ACアダプター<br />
                        3) センサコード（環境センサ接続済み）<br />
                        4) スタートアップガイド<br />
                        5) ユーザーガイド<br />
                    </p>
                    <hr class="thick" />
                </div>
                <h2 class="col5 section_title">
                    <strong> 注意事項 </strong>
                </h2>
                <div class="col7 input_area">
                    <ul class="list-disc">
                        <li>お支払いはクレジットカードのみご利用いただけます。</li>
                        <li>利用できるカードブランドは、VISA、Master、JCB、アメリカン・エキスプレス、ダイナーズです。</li>
                        <li>返金の手続きはクレジット会社を通じて行います。</li>
                        <li>本サービスはレンタルサービスです。</li>
                        <li>本サービスは毎月利用料金の発生する月額サービスです。更新日のお支払いにより1ヶ月の利用権が提供されます。</li>
                        <li>本サービスはご利用開始日より1か月間は無料です。初回のご利用料金のお支払いは2ヶ月目の更新日に発生します。</li>
                        <li>本サービスにはLTE通信料が含まれます。通信量に対する従量課金はなく、毎月定額のお支払いです。</li>
                        <li>本サービスは最低利用期間1年です。13回目の更新日に最低利用期間は解除されます。</li>
                        <li>最低利用期間内の解約の場合は、解約金8,800円(税込)を承ります。</li>
                        <li>レンタル機器はLTE通信を利用します。サービスエリアはNTTドコモの4G LTEサービス利用可能エリアに準じます。3Gおよび5Gの通信には対応しません。</li>
                        <li>
                            サービスエリア内であっても電波状態の悪いところ又は弱いところではご利用できないことがあります。その場合は、サービス利用開始日より7日以内にお客様からお申し出をいただいた場合に限り、解約金をいただだかず解約をお受けいたします。
                        </li>
                        <li>本サービスの解約はネコリコポータル（https://portal.necolico.jp）よりいつでも行えます。</li>
                        <li>本サービス解約後は、1ヶ月以内にレンタル機器を返却いただきます。ご返却なき場合は亡失負担金44,000円(税込)を請求いたします。</li>
                    </ul>
                    <hr class="thick" />
                </div>
                <h2 class="col5 section_title">
                    <strong> 申込みを始める </strong>
                </h2>
                <div class="col7 input_area">
                    <div class="col mt-2em-sp">お申込みにはネコリコアカウントが必要です。<br />お持ちでない場合は「アカウントを作成して申込む」を選択してください。</div>
                    <p class="submit_btn">
                        <input type="submit" @click="signup" value="アカウントを作成して申込む" onsubmit="return false;" />
                    </p>
                    <p class="submit_btn">
                        <input type="submit" @click="login" value="ログインして申込む" onsubmit="return false;" />
                    </p>
                    <hr class="thick" />
                </div>
                <h2 class="col5 section_title">
                    <strong> アカウント作成でお困りの場合は </strong>
                </h2>
                <div class="col7 input_area">
                    <div class="col mt-2em-sp">ネコリコアカウントの作成等お申込に関してお困りの場合は下記までご連絡ください。<br />受付時間:平日9:00~17:00</div>
                    <p class="submit_btn">
                        <input type="submit" @click="callTel()" value="電話:03-5205-4468" class="on-sp" />
                        <input type="submit" value="電話:03-5205-4468" class="off-sp" style="pointer-events: none" />
                    </p>
                    <hr class="thick" />
                </div>
                <!-- wrap_pr_2col input_area -->
            </div>
            <!-- wrapper -->
        </section>
        <!-- container -->
    </div>
</template>

<script>
export default {
    methods: {
        signup: function () {
            // 共通ログイン画面（新規登録導線）へ遷移
            const query = new URLSearchParams({
                np: document.np,
                auth: "signup"
            });
            location.href = `/bocco/rental?${query.toString()}`;
        },
        login: function () {
            // 共通ログイン画面（ログイン導線）へ遷移
            const query = new URLSearchParams({
                np: document.np,
                auth: "login"
            });
            location.href = `/bocco/rental?${query.toString()}`;
        },
        callTel: function () {
            // スマートフォンの場合のみ呼びだされ、指定の電話番号に電話を掛ける
            location.href = "tel:03-5205-4468";
        }
    }
};
</script>

<style scoped>
.flow-item {
    width: 100%;
    text-align: center;
}
.flow-item :first-child {
    background: #ccd100;
    border: solid 2px #ccd100;
    border-bottom: none;
    position: relative;
}
.flow-item :first-child:before {
    content: "";
    width: calc(100% + 4px);
    height: 20px;
    position: absolute;
    bottom: -20px;
    left: -2px;
    background: linear-gradient(to top right, transparent 50%, /* black 30%, */ #ccd100 calc(50% + 2px)) top left/ 50% 100% no-repeat,
        linear-gradient(to top left, transparent 50%, /* black 30%, */ #ccd100 calc(50% + 2px)) top right / 50% 100% no-repeat;
}
</style>
